import React, { useEffect } from 'react';
import cx from 'classnames';
// components
import MultiSelectBox from '@/components/MultiSelectBox';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { Checkbox } from '@swiggy-private/dls-web-core/dist/components/Checkbox';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
//styles
import styles from './CitySearch.module.scss';
const CitySearch = ({ cityOptions, selectedOptions, setSelectedOptions, disabled, errorText, }) => {
    const [availableCityOptions, setAvailableCityOptions] = React.useState(cityOptions);
    useEffect(() => {
        setAvailableCityOptions(cityOptions);
    }, [cityOptions]);
    const selectAllLabel = availableCityOptions.length > 1 ? 'cities' : 'city';
    const renderFunction = (option, _, onClick, className) => {
        const onChange = (e) => {
            onClick(e);
        };
        return (React.createElement("div", { className: cx(styles.option, className) },
            React.createElement(Text, { className: styles.optionText, variant: DlsFontVariants.subheader_S1_Reg, color: DlsColorTokens.text_Med_Emphasis }, option.item.label),
            React.createElement("span", { onMouseDown: onChange },
                React.createElement(Checkbox, { label: "", orientation: "rtl", id: option.id, checked: option.selected }))));
    };
    const onChange = (options) => {
        const selectedOptionsValue = options
            .filter((option) => option.selected)
            .map((option) => option.item.id);
        const selectedPreselectedValue = [];
        const selectedValue = [];
        for (const val of selectedOptions) {
            const matchedItem = options.find((item) => item.id === val);
            if (matchedItem) {
                matchedItem.selected && selectedPreselectedValue.push(val);
            }
            else {
                selectedPreselectedValue.push(val);
            }
        }
        selectedOptionsValue.forEach((option) => {
            const isIncluded = selectedPreselectedValue.includes(option);
            if (!isIncluded) {
                selectedValue.push(option);
            }
        });
        const ids = [...selectedValue, ...selectedPreselectedValue];
        setSelectedOptions(ids);
    };
    return (React.createElement("div", null,
        React.createElement(MultiSelectBox, { openOnFocus: true, autoUpdatePosition: true, selectAllLabel: selectAllLabel, renderFunction: renderFunction, onChange: onChange, values: selectedOptions, options: availableCityOptions, identifier: (item) => item.id, onInputTextChange: (text) => {
                const filteredOptions = cityOptions.filter((option) => option.label.toLowerCase().includes(text.toLowerCase()));
                setAvailableCityOptions(filteredOptions);
            }, inputErrorText: errorText, disabled: disabled })));
};
export default React.memo(CitySearch);
